import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ReportModalDialogComponent } from '../../Billing/report-modal-dialog/report-modal-dialog.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NotificationService } from 'src/app/services/notification-service';
import { InputformatServiceService } from 'src/app/services/inputformat-service.service';
import { MatDatepicker } from '@angular/material/datepicker';
import moment, { Moment } from 'moment';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-additional-features-popup',
    templateUrl: './additional-features-popup.component.html',
    styleUrls: ['./additional-features-popup.component.scss']
})
export class AdditionalFeaturesPopupComponent implements OnInit {
    displayType: any;
    managespForm: FormGroup
    minDate: Date;
    maxDate: Date;
    @ViewChild('effectiveFrom') startDatePicker: MatDatepicker<Date>;
    selectedDate: any;
    date = new FormControl(moment());
    targetForm: FormGroup;
    data: any;
    messageForm: FormGroup
    textform: FormGroup;
    safeHtmlContent

    constructor(@Inject(MAT_DIALOG_DATA) public popupdata: any, private toast: NotificationService,
        private InputformatService: InputformatServiceService, private sanitizer: DomSanitizer,

        public dialogRef: MatDialogRef<ReportModalDialogComponent>,) {
        this.displayType = this.popupdata.title;
        debugger
        this.data = this.popupdata.value
        console.log(this.popupdata);
        if (this.displayType == 'showtext') {
            this.data = this.popupdata.value
            this.safeHtmlContent = this.sanitizer.bypassSecurityTrustHtml(this.data.content);

        }
    }

    ngOnInit() {
        this.FormInit()
        this.stripHtmlAndSetMessage()
    }
    FormInit() {
        this.managespForm = new FormGroup({
            name: new FormControl(null, Validators.required),
            mobileNumber: new FormControl(null, Validators.required),
            email: new FormControl(null, Validators.required),
        })
        this.targetForm = new FormGroup({
            targetCount: new FormControl(null, Validators.required),
            effectiveFrom: new FormControl(null, Validators.required),
        })
        this.messageForm = new FormGroup({
            mobilenumber: new FormControl(null),
            message: new FormControl(null),
            subject: new FormControl(null),
        })

        if (this.data) {
            this.managespForm.patchValue({
                name: this.data.name,
                mobileNumber: this.data.mobileNumber,
                email: this.data.email,
            })
            this.messageForm.patchValue({
                message: this.data.message,
                subject: this.data.subject,

            })

            if (this.data.multipleRecipientString)
                this.messageForm.patchValue({ mobilenumber: this.data.multipleRecipientString })
            else
                this.messageForm.patchValue({ mobilenumber: this.data.messagingNameString })


        }
    }
    stripHtmlAndSetMessage() {
        const rawMessage = this.messageForm.value.message;
        const plainTextMessage = this.stripHtml(rawMessage);
        this.messageForm.get('message')?.setValue(plainTextMessage);
    }

    stripHtml(html: string) {
        const div = document.createElement('div');
        div.innerHTML = html;
        return div.textContent || div.innerText || ''; // Return plain text
    }
    Close() {
        this.dialogRef.close();
    }
    Submit() {
        if (this.managespForm.valid || this.targetForm.valid) {
            debugger
            this.data = { ...this.data, ...this.managespForm.value }
            this.dialogRef.close({ value: this.displayType == 'Manage SPContacts' ? this.data : this.targetForm.value })
        }
        else {
            this.toast.showError("Please fill the require fields!")
            this.managespForm.markAllAsTouched()
            return
        }
    }
    onInputChangeNumber(event: Event, controllerName: any) {
        if (this.managespForm.get(controllerName).value.startsWith('0')) {
            this.managespForm.controls[controllerName].setValue(this.managespForm.get(controllerName).value.slice(1));
        }
    }

    onInput(event: any, regexPattern: any): void {
        this.InputformatService.isNumericOrHyphenOrSpace(event, regexPattern);
    }

    openStartDateDatePicker() {
        this.startDatePicker.open();
    }

}
